module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recipeSearchHeader"
  }, [_c('div', {
    staticClass: "content headerHeight"
  }, [_c('div', {
    staticClass: "alignBottomOfSearch"
  }, [_c('div', {
    staticClass: "recipeWelcome centerAlign"
  }, [(_vm.isBreakfast) ? _c('h1', [_vm._v("Good morning " + _vm._s(_vm.$store.state.user.scope.firstname) + "!")]) : _vm._e(), _vm._v(" "), (_vm.isLunch) ? _c('h1', [_vm._v("Good afternoon " + _vm._s(_vm.$store.state.user.scope.firstname) + "!")]) : _vm._e(), _vm._v(" "), (_vm.isDinner) ? _c('h1', [_vm._v("Good evening " + _vm._s(_vm.$store.state.user.scope.firstname) + "!")]) : _vm._e(), _vm._v(" "), (_vm.isNight) ? _c('h1', [_vm._v("Good night, " + _vm._s(_vm.$store.state.user.scope.firstname))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Lets get started with some healthy recipe ideas")]), _vm._v(" "), _c('mu-row', {
    staticStyle: {
      "margin-bottom": "38px"
    }
  }, [_c('mu-col', {
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "width": "100",
      "desktop": "70",
      "tablet": "70"
    }
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('mu-raised-button', {
    staticClass: "recipeHvrBtn mobileSpacing",
    attrs: {
      "label": "Advanced search"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goSearch.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "recipeHvrBtn",
    attrs: {
      "label": "My favourites"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goFavorites.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('form', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.onBlur),
      expression: "onBlur"
    }],
    staticStyle: {
      "position": "relative"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitSearch.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.q),
      expression: "params.q"
    }],
    staticClass: "recipeSearch",
    attrs: {
      "autocomplete": "off",
      "id": "txtAutoSearch",
      "type": "text",
      "placeholder": "Search by; ingredient, title or category"
    },
    domProps: {
      "value": (_vm.params.q)
    },
    on: {
      "focus": _vm.onFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.params, "q", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.isSearching) ? _c('mu-circular-progress', {
    staticStyle: {
      "width": "24px",
      "height": "24px",
      "position": "absolute",
      "right": "18px",
      "top": "27px"
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-up-down",
      "enter-active-class": "animated fadeInUp",
      "leave-active-class": "animated fadeOutDown"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAutoCompleteOpen && _vm.suggestions.length > 0),
      expression: "isAutoCompleteOpen && suggestions.length > 0"
    }],
    staticClass: "suggestion-wrapper",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "suggestions",
    staticStyle: {
      "position": "absolute"
    }
  }, _vm._l((_vm.suggestions), function(item, index) {
    return _c('div', {
      staticClass: "item",
      class: {
        'active': index === _vm.suggestionIndex
      },
      on: {
        "click": _vm.submitSearch,
        "mouseover": function($event) {
          return _vm.onItemMouseover(index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.title) + "\n              ")])
  }), 0)])]), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "searchArea"
  }), _vm._v(" "), _c('div', {
    staticClass: "recipeGradient"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61c6d5fa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Recipes/Components/RecipeSearchHeader.vue
// module id = 3748
// module chunks = 1